import React from "react";

import AppleWalletSafariHint from "./AppleWalletSafariHint";

const linkStyle = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  width: "110px",
  height: "35px",
  margin: "5px",
};

const AddToAppleWallet = ({ addToAppleWalletIconUrl, href }) => (
  <div className="d-inline-flex flex-column align-items-center">
    <a href={href} style={linkStyle}>
      <img src={addToAppleWalletIconUrl} alt="Add to Apple Wallet" />
    </a>
    <AppleWalletSafariHint className="text-center" />
  </div>
);

export default AddToAppleWallet;
